<template>
  <section class="u_editor" ondragstart="null" onselectstart="null">
    <div contentEditable="true" :id="className" class="u_textEdit"
    @focus="focusHandler" @focusout="focusOutHandler"
    @keydown="keydownHandler" @keyup="keyupHandler"
    @paste="paste" @copy="copy" @cut="cut"
    @mousedown="mousedownHandler" @mouseup="mouseupHandler"
    @dragstart="dragstart" @drop="drop" @change="changeHandler">
    </div>
    <!-- <div class="textbody"> -->

      <!-- <div class="placeholder">{{defaultTextCardString}}</div> -->
    <!-- </div> -->
  </section>
</template>

<script>
import ES from '@/components/js/EditorSetting.js'
import Editor from '@/components/js/Editor.js'
import {resetRange, eventRange, selection} from '@/components/js/Utils.js'

var editor = new Editor('.selectTarget')
var focusRange = null
export default {
  props: {
    isReFocus: { type: Boolean },
    range: { type: Range },
    type: { type: String },
    title: { type: String },
    bold: { type: Boolean },
    italic: { type: Boolean },
    underline: { type: Boolean },
    strike: { type: Boolean },
    align: { type: String },
    indent: { type: Boolean },
    font: { type: String },
    size: { type: String },
    foreColor: { type: String },
    backColor: { type: String },
    editStyle: { type: String },
    initBody: { type: String },
    link: { type: String },
    isPoint: {type: Boolean, default: false},
    className: {type: String, default: 'u_textEdit'}
  },
  data: function () {
    return {
      hideCursor: false,
      defaultTextCardString: '내용을 입력하세요.',
      show: true,
      editor: editor,
      cutData: null
    }
  },
  created () {
    // console.log(editor)
  },
  name: 'Ueditor',
  watch: {
    initBody: {
      immediate: true,
      handler (val, oldVal) {
        console.log('initBody')
        // console.log('initbody', val)
        // console.log(this)
        if (val != null) {
          var e = document.querySelector('#' + this.className)
          if (e) {
            // e.innerHTML = ''
            e.innerHTML = val
            // var d = document.createElement('div')
            // d.innerHTML = this.initBody
            // editor.removeTag(d, 'style')
            // d = d.firstChild
            // while (d.firstChild) {
            //   e.appendChild(d.firstChild)
            // }
          }
          // console.log(e)
        }
        // this.initBody = val
      }
    }
  },
  mounted () {
    console.log('editor mounted')
    this.show = false
    editor.update = this.updateOption
    editor.resetType = this.resetType
    document.execCommand('defaultParagraphSeparator', false, ES.ENTER)
    console.log('initBody', this.initBody)
    if (this.initBody) {
      var e = document.querySelector('#' + this.className)
      e.innerHTML = this.initBody
    } else {
      var temp = document.createElement(ES.ENTER)
      temp.align = ES.ALIGN_LEFT
      // temp.innerHTML = this.defaultTextCardString
      temp.appendChild(document.createElement('br'))
      document.querySelector('#' + this.className).appendChild(temp)
    }
    setTimeout(() => {
      console.log(this.className, document.querySelector('#' + this.className))
      document.querySelector('#' + this.className).focus()
    })
  },
  methods: {
    mousedownHandler (e) {
      if (document.querySelector(ES.SELECT)) {
        document.querySelector(ES.SELECT).classList.remove(ES.toSELECT)
      }
      var t = this.$center.dispatchStep(ES.MOUSEDOWN, e)
      if (t.length) {
        this.updateOption('type', t[0])
      } else {
        this.updateOption('type', editor.getType(e))
      }
    },
    mouseupHandler (e) {
      setTimeout(() => {
        editor.updateTool(this.type)
      })
    },
    resetType () {
      console.log('resetType')
      if (document.querySelector(ES.SELECT)) {
        document.querySelector(ES.SELECT).classList.remove(ES.toSELECT)
      }
      console.log(editor.range)
      var t = this.$center.dispatchStep(ES.MOUSEDOWN, {target: editor.range.startContainer})
      if (t.length) {
        this.updateOption('type', t[0])
      } else {
        this.updateOption('type', editor.getType({target: editor.range.startContainer}))
      }
    },
    updateOption (type, value) {
      // console.log('updateOption', type, value, this)
      switch (type) {
        case ES.toolStyle :
          this.$emit('update:editStyle', value)
          break

        case ES.toolSTRIKE :
          this.$emit('update:strike', value)
          break

        case ES.toolFONT :
          this.$emit('update:font', value)
          break

        case ES.toolLINK :
          this.$emit('update:link', value)
          break

        default :
          this.$emit('update:' + type, value)
          break
      }
    },
    changeTool (cmd, value) {
      console.log('changeTool', cmd, value)
      switch (cmd) {
        case ES.toolLINE :
        case ES.toolIMG :
          if (!this.selectionPopup({preventDefault: () => {}}, (e) => {
            document.querySelector('#' + this.className).contentEditable = true
            resetRange(focusRange)
            if (e.result) {
              this.$center.dispatchStep(ES.REMOVE, {})
              document.execCommand('delete', false, null)
              editor.command(this.type, focusRange, cmd, value)
            } else {

            }
          })) {
            editor.command(this.type, focusRange, cmd, value)
          }
          break
        default :
          editor.command(this.type, focusRange, cmd, value)
          break
      }
    },
    focusHandler (e) {
      console.log('focusHandler', e)
      if (this.type === '') {
        // editor.setType({target: editor.range.startContainer})
      }
    },
    focusOutHandler (e) {
      console.log('focusOutHandler', e)
      focusRange = editor.range
      this.$emit('update:range', focusRange)
      if (this.isReFocus) {
        console.log('focusout check')
        resetRange(focusRange)
        this.$emit('update:isReFocus', false)
      }
    },
    keydownHandler (e) {
      if (!this.isPopup) {
        // console.log(e)
        if (ES.isCollapsed) {
          // console.log('isCollapsed', e)
          this.$center.dispatchStep(ES.KEYDOWN, e)
          if (!e.defaultPrevented) {
            if (!e.ctrlKey && !e.shiftKey && !e.altKey) {
              editor.keydown(this.type, e)
            }
          }
        } else {
          switch (e.keyCode || e.which) {
            case 16 :
            case 17 :
            case 27 :
            case 37 :
            case 38 :
            case 39 :
            case 40 :
              break
            default :
              console.log('selectionPopup', e)
              if (!e.ctrlKey && !e.shiftKey && !e.altKey) {
                if (!this.selectionPopup(e, (e) => {
                  document.querySelector('#' + this.className).contentEditable = true
                  if (e.result) {
                    this.$center.dispatchStep(ES.REMOVE, e)
                    document.execCommand('delete', false, null)
                  }
                })) {
                  this.$center.dispatchStep(ES.REMOVE, e)
                  editor.keydown(this.type, e)
                }
              }
              // console.log(this.isCollapsed())
              break
          }
        }
      } else {
        e.preventDefault()
      }
    },
    keyupHandler (e) {
      // console.log(e)
      // e.preventDefault()
    },
    copy (e) {
      this.$center.dispatchStep(ES.COPY, e)
      if (!e.defaultPrevented) {
        editor.copy(this.type, e)
      }
    },
    cut (e) {
      this.$center.dispatchStep(ES.CUT, e)
      if (!e.defaultPrevented) {
        editor.cut(this.type, e)
        console.log('remove start')
        var s = selection()
        console.log(s, s.anchorOffset, s.extentOffset)
        if ((s.anchorOffset === 0 && s.extentOffset === 0 && s.isCollapsed === false) || s.anchorOffset !== s.extentOffset) {
          this.$center.dispatchStep(ES.REMOVE, {type: 'cut'})
          document.execCommand('delete', null, null)
        }
      } else {
        this.updateOption('type', editor.getType({target: editor.range.startContainer}))
      }
    },
    paste (e) {
      e.pasteHTML = editor.pasteHTML(e)
      if (!ES.isCollapsed) {
        console.log('isCollapsed true')
        if (!this.selectionPopup(e, (p) => {
          document.querySelector('#' + this.className).contentEditable = true
          if (p.result) {
            this.$center.dispatchStep(ES.REMOVE, {pasteHTML: e.pasteHTML})
            this.$center.dispatchStep(ES.PASTE, {pasteHTML: e.pasteHTML})
            editor.paste(e)
          }
        })) {
          this.$center.dispatchStep(ES.PASTE, e)
          editor.paste(e)
          e.preventDefault()
        }
      } else {
        console.log('isCollapsed false')
        this.$center.dispatchStep(ES.PASTE, e)
        editor.paste(e)
        e.preventDefault()
      }
    },
    selectionPopup (e, cb) {
      console.log(e)
      var t = this.$center.dispatchStep(ES.SELECTION, e)
      console.log(t)
      if (t.length) {
        setTimeout(() => {
          this.confirm({
            message: '선택된 ' + t.join(',') + ' 을 삭제 하시겠습니까?',
            icon: 'edit_delete',
            data: e
          }, cb)
        })
        document.querySelector('#' + this.className).contentEditable = false
        e.preventDefault()
        return true
      }
      return false
    },
    dragstart (e) {
      // this.$center.dispatchStep(ES.DRAGSTART, e)
      var t = this.$center.dispatchStep(ES.SELECTION, e)
      console.log(t)
      if (t.length) {
        var k = editor.range.cloneContents()
        console.log('cpo', k)
        var m = ''
        k.childNodes.forEach((n) => {
          console.log(n.nodeType, n.nodeValue)
          switch (n.nodeType) {
            case 3 :
              m += n.nodeValue
              break
            case 1 :
              m += n.outerHTML
              break
          }
        })
        console.log('copy', m)
        e.dataTransfer.clearData()
        e.dataTransfer.setData('text/html', m)
      } else {
        editor.dragstart(this.type, e)
      }
    },
    drop (e) {
      var t = this.$center.dispatchStep(ES.SELECTION, e)
      console.log('drop', t)
      if (t.length) {
        e.pasteHTML = editor.dragHTML(e)
        this.$center.dispatchStep(ES.REMOVE, {type: 'drop'})
        console.log('drop 1', e.pasteHTML)
        this.$center.dispatchStep(ES.PASTE, {pasteHTML: e.pasteHTML})
        editor.range.deleteContents()
        resetRange(eventRange(e))
        editor.paste(e)
        e.preventDefault()
      } else {
        editor.drop(this.type, e)
      }
    },
    changeHandler () {
      console.log('changeHandler')
    },
    selectstart (e) {
      console.log('selectstart', e)
    },
    select (e) {
      console.log('selectionchange', e)
    }
  }
}
</script>

<style>
.dragtarget {
  align-items: center;
  cursor: pointer;
  height: 20px;
  width: 100%;
}
.selectTarget {
  background: #FAF4C0;
}
.draggableTargetUp {
  border-top: 2px solid #00FF00;
}
.draggableTargetDown {
  border-bottom: 2px solid #00FF00;
}
.u_editor a {
  text-decoration: underline;
  white-space: normal;
}
.u_editor img::selection {
  background: #FAF4C0;
}
.indent {
  text-indent: 15px;
}
</style>

<style scoped>
p {
  margin: 0px;
  padding: 0em 0px 0em 0px;
  margin-block-start: 0px;
  margin-block-end: 0px;
  min-height: 1.78em;
}
.u_editor {
  width: 500px;
  display: inline-flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 30px;
}
.u_editor hr {
  margin-bottom: 20px;
}
.u_titleBox {
  height: auto;
  display: flex;
  align-items: center;
}
.u_titleArea {
  width: 100%;
  resize: none;
  border: 0px;
  outline: 0;
  overflow: hidden;
}
.u_title {
  margin-top: 20px;
  font-size: 36px;
  font-weight: 600;
}
.u_subtitle {
  font-size: 16px;
  font-weight: 600;
}
.dim {
  color: #BBBBBB;
}
.textbody {
  position: relative;
}
.placeholder {
  display: flex;
  position: absolute;
  top: 1em;
  padding-left: 10px;
  color: #AAAAAA;
  user-select: none;
  z-index: 0;
  white-space: pre-wrap;
  cursor: text;
}
.u_textEdit {
  line-height: 1.8em;
  outline: 0;
  cursor: text;
  white-space: normal;
  display: block;
  z-index: 1;
  word-wrap: break-word;
  word-break: break-all;
  -webkit-line-break: after-white-space;
  -webkit-font-smoothing: antialiased;
}
.u_textEdit {
  /* -webkit-user-modify: read-write; */
}
.hideCursor:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/Editor.vue